export const VARIANT = {
    PAGE: 0,
    ARTICLE: 1
};